import { render, staticRenderFns } from "./Telas-admin.vue?vue&type=template&id=bc73b8b8"
import script from "./Telas-admin.vue?vue&type=script&lang=js"
export * from "./Telas-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports